import { useEffect, useState } from 'react';

import { GoodsCounterAccounts } from '../../../../../../common/models/goods-counter-accounts';
import { useThunkDispatch } from '../../../../../../store/use-thunk-dispatch';

/**
 * Where goods for an invoice address in this country are booked by default.
 * The rule lives in the backend (#2263), so the editor only asks.
 */
export const useGoodsCounterAccounts = (country?: string | null): GoodsCounterAccounts | undefined => {
    const dispatch = useThunkDispatch();
    const [accounts, setAccounts] = useState<GoodsCounterAccounts>();

    useEffect(() => {
        setAccounts(undefined);

        if (!country) {
            return;
        }

        let cancelled = false;

        void dispatch(async (_dispatch, _getState, { api }) => {
            const result = await api.taxRates.getGoodsCounterAccounts(country);

            if (!cancelled && result.success) {
                setAccounts(result.result);
            }
        });

        return () => {
            cancelled = true;
        };
    }, [country, dispatch]);

    return accounts;
};
